import React from 'react';
import { Link } from 'react-router-dom';
import { BUSINESS } from '../pages/Legal';

export default function Footer({ dark = false }) {
  const base = dark ? 'text-white/70' : 'text-muted-foreground';
  const strong = dark ? 'text-white' : 'text-foreground';
  return (
    <footer className={`px-5 py-6 text-center text-xs ${base}`}>
      <div className="mx-auto max-w-xl">
        <p className={`font-semibold ${strong}`}>{BUSINESS.name}</p>
        <p>{BUSINESS.location} · <a href={`mailto:${BUSINESS.email}`} className="underline underline-offset-2">{BUSINESS.email}</a></p>
        <div className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
          <Link to="/terms" className="underline underline-offset-2">Terms</Link>
          <span>·</span>
          <Link to="/privacy" className="underline underline-offset-2">Privacy</Link>
          <span>·</span>
          <Link to="/disclaimer" className="underline underline-offset-2">Disclaimer</Link>
        </div>
        <p className="mt-2">© {new Date().getFullYear()} {BUSINESS.name}. Not a substitute for professional veterinary care.</p>
      </div>
    </footer>
  );
}
